export const USER_SEND_INVITATION = "userSendInvitation";
export const USER_LOGIN = "userLogin";
export const USER_LOGOUT = "userLogout";
export const USER_ACTIVATION = "userActivation";
export const REFRESH_ACCESS_TOKEN = "refreshAccessToken";
